import { render, staticRenderFns } from "./TimeBanner.vue?vue&type=template&id=8b16892a&scoped=true"
import script from "./TimeBanner.vue?vue&type=script&lang=js"
export * from "./TimeBanner.vue?vue&type=script&lang=js"
import style0 from "./TimeBanner.vue?vue&type=style&index=0&id=8b16892a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b16892a",
  null
  
)

export default component.exports